module.exports = __webpack_public_path__ + "img/weaponx.a7b5afd9.svg";